<template>
  <div class="index-box">
    <!-- 校徽及释义 -->
    <div v-if="definition != ''">
      <div class="FirstLevelTitle charmAndGrace">
        <div>校徽及释义</div>
      </div>
      <div class="listCard">
        <div class="deImg">
          <img class="topImgL" :src="definition.badge" />
          <img class="topImgR" :src="definition.apply" />
        </div>
        <div class="contentTxt">
          <!-- <div v-for="(segment, index) in definitionIntro" :key="index">
            {{ segment }}
          </div> -->
          <div v-for="(segment, index) in definitionIntro" :key="index">
          <div
            v-if="segment.includes('<img')"
            v-html="segment"
            class="card_tail_content"
          ></div>
          <div
            v-else
            v-html="segment"
            class="card_tail_content"
            style="text-indent: 4ch"
          ></div>
        </div>

        </div>
      </div>
    </div>
    <!-- 校徽及释义 -->
    <div v-if="specification != ''">
      <div class="FirstLevelTitle charmAndGrace">
        <div>校徽使用规范</div>
      </div>
      <div class="listCard">
        <div class="speImg">
          <img class="topImgL" :src="specification.motto" />
        </div>
        <div class="contentTxt">
          <div
            v-for="(specification, index) in specificationGuifan"
            :key="index"
          >
            {{ specification }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      definition: [], //释义
      definitionIntro: [],
      specification: [], //规范
      specificationGuifan: [],
    };
  },
  created() {
    this.getDefinition();
    this.getSpecification();
  },
  methods: {
    // 获取释义
    async getDefinition() {
      const result = await this.$http.get("/SchoolId/getSchoolBadgePage");
      console.log("获取释义", result.data);
      this.definition = result.data;

      const sanitizedString = result.data.intro.replace(
        /<br>|<br\/>/g,
        ""
      );
      const list = sanitizedString
        .split("</p>")
        .map((p) => p.replace("<br/>", ""));
      this.definitionIntro = list;

      // const content = result.data.intro.split("\n");
      // // 重新组合分段，包含关键字
      // const definitionIntro = [];
      // for (let i = 0; i < content.length; i++) {
      //   definitionIntro.push(content[i]);
      // }
      // this.definitionIntro = definitionIntro;
    },
    // 获取规范
    async getSpecification() {
      const result = await this.$http.get("/SchoolId/getSchoolMottoPage");
      console.log("获取规范", result.data[0]);
      this.specification = result.data[0];
      const content = result.data[0].guifan.split("\n");
      // 重新组合分段，包含关键字
      const specificationGuifan = [];
      for (let i = 0; i < content.length; i++) {
        specificationGuifan.push(content[i]);
      }
      this.specificationGuifan = specificationGuifan;
    },
  },
};
</script>
<style lang="less" scoped>
.index-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .listCard {
    display: flex;
    flex-direction: column;
    width: 95vw;
    border-radius: 10px;
    border: 1px solid #e2e2e2;
    background: #fff;
    font-size: 1rem;
    font-weight: 500;
    line-height: 25px; //行间距
    color: #747474;
    text-indent: 4ch; //首行缩进
    text-align: justify; //两端对齐
    margin-top: 10px;
    padding-bottom: 10px;
    .deImg {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-top: 15px;
      .topImgL {
        margin-left: 15%;
        position: relative;
        display: flex;
        width: 25vw;
        image-rendering: -moz-crisp-edges;
        image-rendering: -o-crisp-edges;
      }
      .topImgR {
        margin-right: 15%;
        position: relative;
        display: flex;
        width: 25vw;
        image-rendering: -moz-crisp-edges;
        image-rendering: -o-crisp-edges;
      }
    }

    .contentTxt {
      padding: 0.5rem 1rem 1rem 1rem;
      line-height: 25px;
    }
    .card_tail_content {
      padding: 0.5rem 1rem 0.5rem 1rem;
      line-height: 25px;
      margin-bottom: -2rem;
      // margin-top:-1.5rem;
    }

    .speImg {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      margin-top: 15px;

      .topImgL {
        // margin-left: 15%;
        position: relative;
        display: flex;
        width: 60vw;
        image-rendering: -moz-crisp-edges;
        image-rendering: -o-crisp-edges;
        margin-bottom: 10px;
      }
      .topImgR {
        // margin-right: 15%;
        position: relative;
        display: flex;
        width: 60vw;
        image-rendering: -moz-crisp-edges;
        image-rendering: -o-crisp-edges;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alumniHome/Identification.vue